import React from 'react'
import styled from 'styled-components'
import Gallery from 'react-grid-gallery'

const images = [
  {
    src: "/img/projects/sample-1.jpg",
    thumbnail: "/img/projects/sample-1.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 240,
    isSelected: false,
  },
  {
    src: "/img/projects/sample-2.jpg",
    thumbnail: "/img/projects/sample-2.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 240,
    isSelected: false,
  },
  {
    src: "/img/projects/sample-3.jpg",
    thumbnail: "/img/projects/sample-3.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 240,
    isSelected: false,
  },
  {
    src: "/img/projects/sample-4.jpg",
    thumbnail: "/img/projects/sample-4.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 240,
    isSelected: false,
  },
  {
    src: "/img/projects/sample-5.jpg",
    thumbnail: "/img/projects/sample-5.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 240,
    isSelected: false,
  },
  {
    src: "/img/projects/sample-7.jpg",
    thumbnail: "/img/projects/sample-7.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 240,
    isSelected: false,
  },
  {
    src: "/img/projects/sample-9.jpg",
    thumbnail: "/img/projects/sample-9.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 240,
    isSelected: false,
  },
  {
    src: "/img/projects/sample-10.jpg",
    thumbnail: "/img/projects/sample-10.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 240,
    isSelected: false,
  },
  {
    src: "/img/projects/sample-13.jpg",
    thumbnail: "/img/projects/sample-13.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 240,
    isSelected: false,
  },
  {
    src: "/img/projects/sample-16.jpg",
    thumbnail: "/img/projects/sample-16.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 426,
    isSelected: false,
  },
  {
    src: "/img/projects/project-03122023-1.jpg",
    thumbnail: "/img/projects/project-03122023-1.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 240,
    isSelected: false,
  },
  {
    src: "/img/projects/project-03122023-2.jpg",
    thumbnail: "/img/projects/project-03122023-2.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 426,
    isSelected: false,
  },
  {
    src: "/img/projects/project-03122023-3.jpg",
    thumbnail: "/img/projects/project-03122023-3.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 240,
    isSelected: false,
  },
  {
    src: "/img/projects/project-03122023-4.jpg",
    thumbnail: "/img/projects/project-03122023-4.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 240,
    isSelected: false,
  },
  {
    src: "/img/projects/project-03122023-5.jpg",
    thumbnail: "/img/projects/project-03122023-5.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 240,
    isSelected: false,
  },
  {
    src: "/img/projects/project-03122023-6.jpg",
    thumbnail: "/img/projects/project-03122023-6.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 240,
    isSelected: false,
  },
  {
    src: "/img/projects/project-03122023-7.jpg",
    thumbnail: "/img/projects/project-03122023-7.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 426,
    isSelected: false,
  },
  {
    src: "/img/projects/project-03122023-8.jpg",
    thumbnail: "/img/projects/project-03122023-8.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 426,
    isSelected: false,
  },
  {
    src: "/img/projects/project-03122023-9.jpg",
    thumbnail: "/img/projects/project-03122023-9.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 426,
    isSelected: false,
  },
  {
    src: "/img/projects/project-03122023-10.jpg",
    thumbnail: "/img/projects/project-03122023-10.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 426,
    isSelected: false,
  },
  {
    src: "/img/projects/project-03122023-11.jpg",
    thumbnail: "/img/projects/project-03122023-11.jpg",
    thumbnailWidth: 320,
    thumbnailHeight: 426,
    isSelected: false,
  },

  {
    src: "/img/projects/project-02012024-1.jpg",
    thumbnail: "/img/projects/project-02012024-1.jpg",
    thumbnailWidth: 403,
    thumbnailHeight: 302,
    isSelected: false,
  },
  {
    src: "/img/projects/project-02012024-2.jpg",
    thumbnail: "/img/projects/project-02012024-2.jpg",
    thumbnailWidth: 302,
    thumbnailHeight: 403,
    isSelected: false,
  },
  {
    src: "/img/projects/project-02012024-3.jpg",
    thumbnail: "/img/projects/project-02012024-3.jpg",
    thumbnailWidth: 403,
    thumbnailHeight: 302,
    isSelected: false,
  },
  {
    src: "/img/projects/project-02012024-4.jpg",
    thumbnail: "/img/projects/project-02012024-4.jpg",
    thumbnailWidth: 400,
    thumbnailHeight: 220,
    isSelected: false,
  },
  {
    src: "/img/projects/project-02012024-5.jpg",
    thumbnail: "/img/projects/project-02012024-5.jpg",
    thumbnailWidth: 400,
    thumbnailHeight: 220,
    isSelected: false,
  },
  {
    src: "/img/projects/project-02012024-6.jpg",
    thumbnail: "/img/projects/project-02012024-6.jpg",
    thumbnailWidth: 403,
    thumbnailHeight: 302,
    isSelected: false,
  },
  {
    src: "/img/projects/project-02012024-7.jpg",
    thumbnail: "/img/projects/project-02012024-7.jpg",
    thumbnailWidth: 403,
    thumbnailHeight: 302,
    isSelected: false,
  },
  {
    src: "/img/projects/project-08092025-1.jpeg",
    thumbnail: "/img/projects/project-08092025-1.jpeg",
    thumbnailWidth: 403,
    thumbnailHeight: 302,
    isSelected: false,
  },
  {
    src: "/img/projects/project-08092025-2.jpeg",
    thumbnail: "/img/projects/project-08092025-2.jpeg",
    thumbnailWidth: 403,
    thumbnailHeight: 302,
    isSelected: false,
  },
  {
    src: "/img/projects/project-08092025-3.jpeg",
    thumbnail: "/img/projects/project-08092025-3.jpeg",
    thumbnailWidth: 403,
    thumbnailHeight: 302,
    isSelected: false,
  },
  {
    src: "/img/projects/project-08092025-4.jpeg",
    thumbnail: "/img/projects/project-08092025-4.jpeg",
    thumbnailWidth: 403,
    thumbnailHeight: 302,
    isSelected: false,
  },
  {
    src: "/img/projects/project-08092025-5.jpeg",
    thumbnail: "/img/projects/project-08092025-5.jpeg",
    thumbnailWidth: 403,
    thumbnailHeight: 472,
    isSelected: false,
  },
  {
    src: "/img/projects/project-08092025-6.jpeg",
    thumbnail: "/img/projects/project-08092025-6.jpeg",
    thumbnailWidth: 403,
    thumbnailHeight: 302,
    isSelected: false,
  },
  {
    src: "/img/projects/project-08092025-7.jpeg",
    thumbnail: "/img/projects/project-08092025-7.jpeg",
    thumbnailWidth: 403,
    thumbnailHeight: 302,
    isSelected: false,
  },
  {
    src: "/img/projects/project-08092025-8.jpeg",
    thumbnail: "/img/projects/project-08092025-8.jpeg",
    thumbnailWidth: 403,
    thumbnailHeight: 302,
    isSelected: false,
  },
  {
    src: "/img/projects/project-08092025-9.jpeg",
    thumbnail: "/img/projects/project-08092025-9.jpeg",
    thumbnailWidth: 403,
    thumbnailHeight: 302,
    isSelected: false,
  },
  {
    src: "/img/projects/project-08092025-10.jpeg",
    thumbnail: "/img/projects/project-08092025-10.jpeg",
    thumbnailWidth: 403,
    thumbnailHeight: 302,
    isSelected: false,
  },
  {
    src: "/img/projects/project-08092025-11.jpeg",
    thumbnail: "/img/projects/project-08092025-11.jpeg",
    thumbnailWidth: 403,
    thumbnailHeight: 302,
    isSelected: false,
  },
  {
    src: "/img/projects/project-08092025-12.jpeg",
    thumbnail: "/img/projects/project-08092025-12.jpeg",
    thumbnailWidth: 403,
    thumbnailHeight: 404,
    isSelected: false,
  },
  {
    src: "/img/projects/project-08092025-13.jpeg",
    thumbnail: "/img/projects/project-08092025-13.jpeg",
    thumbnailWidth: 403,
    thumbnailHeight: 302,
    isSelected: false,
  },
  {
    src: "/img/projects/project-08092025-14.jpeg",
    thumbnail: "/img/projects/project-08092025-14.jpeg",
    thumbnailWidth: 403,
    thumbnailHeight: 302,
    isSelected: false,
  },
  {
    src: "/img/projects/project-08092025-15.jpeg",
    thumbnail: "/img/projects/project-08092025-15.jpeg",
    thumbnailWidth: 403,
    thumbnailHeight: 505,
    isSelected: false,
  },
]

const Container = styled.div`
  padding-top: ${props => props.theme.spacing * 2}px;
  margin-left: ${props => props.theme.spacing * 4}px;
  margin-right: ${props => props.theme.spacing * 4}px;
  padding-bottom: ${props => props.theme.spacing * 2}px;
`

const Header = styled.h3`
  text-align: center;
  font-size: 2rem;
  color: ${props => props.theme.palette.primary.contrast};
  margin-bottom: ${props => props.theme.spacing * 4}px;
`

const Projects = (props) => {
  return (
    <Container {...props}>
      <Header>Projects Gallery</Header>
      <Gallery images={images} />
    </Container>
  )
}

export default Projects